module.exports = __webpack_public_path__ + "img/p3.038d31d7.png";